import React from "react";
import * as Styles from "../../../../../common-deprecated/styles/v2/lexus/components/Swatches";
import { useCompareV2Selector } from "../../../redux/store";
import useSelectSwatch from "../../../hooks/useSelectSwatch";
import SrOnly from "../../../../../common-deprecated/styles/v2/lexus/utilities/ScreenreaderOnly";
import { useCompareV2Label } from "../../../utils/labels";
import type { AvailableColoursType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";

export type SelectSwatchPropsType = {
    availableColours: AvailableColoursType[];
    selectedColourCode: string;
    swatchSelectHeight: number;
    setSwatchSelectHeight: (newHeight: number) => void;
    index: number;
};

const SelectSwatch = (props: SelectSwatchPropsType): JSX.Element => {
    const { availableColours, selectedColourCode, setSwatchSelectHeight, swatchSelectHeight, index } = props;
    const settings = useCompareV2Selector((state) => state.compareV2Settings);
    const { changeColour, wrapperRef } = useSelectSwatch(index, swatchSelectHeight, setSwatchSelectHeight);

    const ariaLabel = useCompareV2Label("compareNCA11yColors");

    return (
        <Styles.Wrapper ref={wrapperRef} height={swatchSelectHeight} role="list" aria-label={ariaLabel}>
            {availableColours &&
                availableColours.map((colour) => (
                    <Styles.Item key={colour.code} role="listitem">
                        <Styles.Button
                            type="button"
                            asset={colour.asset ? settings.cardbImageHost + colour.asset : ""}
                            active={selectedColourCode === colour.code}
                            color={`#${colour.rgb}`}
                            onClick={() => changeColour(colour.code)}
                            aria-label={colour.name}
                        >
                            <SrOnly>{colour.name}</SrOnly>
                        </Styles.Button>
                    </Styles.Item>
                ))}
        </Styles.Wrapper>
    );
};

export default SelectSwatch;
